import { NavLink, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { LEAGUE } from "../../config/league";
import { useEtClock } from "../lib/format";

const NAV = [
  { to: "/", label: "Season" },
  { to: "/draft", label: "Draft" },
  { to: "/universe", label: "Draft Pool" },
  { to: "/transactions", label: "Transactions" },
  { to: "/admin", label: "Admin" },
];

export function Layout({ children }: { children: ReactNode }) {
  const loc = useLocation();
  // Broadcast view is chrome-free for the stream overlay.
  if (loc.pathname.startsWith("/broadcast")) {
    return <>{children}</>;
  }
  const clock = useEtClock();

  return (
    <div className="min-h-full">
      <header className="sticky top-0 z-20 border-b border-edge bg-ink-950/80 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-2 px-4 py-3 sm:px-5">
          <div className="flex min-w-0 items-center gap-3 sm:gap-6">
            <NavLink to="/" className="flex items-center gap-2.5">
              <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-gradient-to-br from-accent to-gain text-sm font-black text-ink-950">
                ↑↓
              </span>
              <span className="hidden text-sm font-bold uppercase tracking-[0.18em] text-fg sm:inline">
                {LEAGUE.brandName}
              </span>
            </NavLink>
            <nav className="flex items-center gap-0.5 sm:gap-1">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.to === "/"}
                  className={({ isActive }) =>
                    `rounded-lg px-2.5 py-1.5 text-sm font-medium transition sm:px-3 ${
                      isActive
                        ? "bg-ink-700 text-fg"
                        : "text-muted hover:text-fg"
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="num hidden items-center gap-2 text-sm text-muted sm:flex">
            <span className="text-faint">ET</span>
            <span className="tabular text-fg">{clock}</span>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-6">{children}</main>
    </div>
  );
}
